import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'common/components/antd/Button/Button';
import { Drawer } from 'common/components/antd/Drawer/Drawer';
import { Tag } from 'common/components/antd/Tag/Tag';

type TFields = {
  key?: string;
  value?: string;
}

type TProps = {
  fields: TFields[];
}

export const RenderDrawerComponent = ({ fields } : TProps): React.ReactElement => {
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const { t } = useTranslation();
  const showDrawer = (): void => setOpenDrawer(true);
  const onCloseDrawer = (): void => setOpenDrawer(false);
  const dataToString = (values: TFields[]): string => JSON.stringify(values, null, 2);

  return (
    <div>
    {(fields?.length <= 2)
      ? (
        <Tag style={{ whiteSpace: 'wrap' }}>
          <pre>
            {dataToString(fields)}
          </pre>
        </Tag>
      )
      : (
        <Tag style={{ whiteSpace: 'wrap' }}>
          <pre>
            {dataToString([fields[0], fields[1]])}
          </pre>
          <Button type="primary" onClick={showDrawer}>...</Button>
          <Drawer
            title={t('reporting.audit.table.column.fields.drawer.title')}
            onClose={onCloseDrawer}
            open={openDrawer}
          >
            <pre>
              {dataToString(fields)}
            </pre>
          </Drawer>
        </Tag>
      )
    }
    </div>
  );
};
